import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Spinner from 'web/components/Spinner';
import Layout from 'web/components/Layout';
import OrderTabs from './OrderTabs/OrderTabs'
import { Container } from './myOrderStyled'
import { Helmet } from "react-helmet";

const MyOrder = (props) => {
  const [urlSearchParams, setURLSearchParams] = useState();
  let history = useHistory();
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const urlObject = useSelector((state) => state.urlParameters.orders);
  const accountType = localStorage.getItem('accountType')
  const selectedSearch = accountType === "Seller" ? "PostLoad" : accountType === "Buyer" ? "PostInventory" : null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const { location } = props;
    const queryParams = new URLSearchParams(location.search)

    if (queryParams.get("pageType")) {
      setURLSearchParams({
        pageType: queryParams.get("pageType"),
        selectedTab: queryParams.get("selectedTab"),
      })
    } else {
      if (urlObject) {
        setURLSearchParams({
          pageType: urlObject.pageType,
          selectedTab: urlObject.selectedTab,
        })
      } else {
        setURLSearchParams({
          pageType: 'MyOrder',
          selectedTab: queryParams.get("selectedTab"),
        })
      }
    }
  }, []);

  return (<>
    <Helmet title="My Orders: Track and Manage Your Orders | PalletTrader" >
      <meta name="description"
        content="Manage pallet sales and procurement transactions seamlessly. Pallet buyers and sellers have complete shipment visibility from bid or offer acceptance through delivery." />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href="https://www.pallettrader.com/my-orders" />
    </Helmet>
    <Layout pageType="orderPage" selectedSearch={selectedSearch} topBarViewMobile={'hide'}>
      {loaderVisible && <Spinner />}
      <Container>
        {urlSearchParams && <OrderTabs urlSearchParams={urlSearchParams} />}
      </Container>
    </Layout>
  </>)
};

export default MyOrder;